import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { AttendanceTab } from './AttendanceTab';
import { LeaveTab } from './LeaveTab';
import { PayrollTab } from './PayrollTab';
import { SalariesTab } from './SalariesTab';

type Tab = 'attendance' | 'leave' | 'salaries' | 'payroll';

export function HrPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('attendance');
  const tabs: Tab[] = [];
  if (schoolId && can('staff_attendance.view', schoolId)) tabs.push('attendance');
  if (schoolId && can('hr_leave.view', schoolId)) tabs.push('leave');
  if (schoolId && can('salary.view', schoolId)) tabs.push('salaries');
  if (schoolId && can('payroll.view', schoolId)) tabs.push('payroll');
  const active = tabs.includes(tab) ? tab : tabs[0];

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('hr.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && active && (
        <>
          <div
            role="tablist"
            aria-label={t('hr.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={active === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${active === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`hr.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {active === 'attendance' && <AttendanceTab schoolId={schoolId} />}
            {active === 'leave' && <LeaveTab schoolId={schoolId} />}
            {active === 'salaries' && <SalariesTab schoolId={schoolId} />}
            {active === 'payroll' && <PayrollTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
